export default class Channel {
  constructor(id, name) {
    this.id = id;
    this.name = name;
  }
}



// WEBPACK FOOTER //
// ./src/classes/Channel.js